module.exports = __webpack_public_path__ + "static/BT_pirates-02-dfbcfcb4c2b1207e82a10f616667047d.png";